define('glu/grid/multiColumnSort/multiColumnSortView',['require','../../itemView','../../dialog','../../collection','../../locale','../../util','./manageDialogLayout','hbs!./multiColumnSortView.hbs'],function(require) {
    'use strict';

    var ItemView = require('../../itemView'),
        dialog = require('../../dialog'),
        Collection = require('../../collection'),
        locale = require('../../locale'),
        util = require('../../util'),
        ManageDialogLayout = require('./manageDialogLayout');

    return ItemView.extend({
        template: require('hbs!./multiColumnSortView.hbs'),

        ui: {
            'switch': '.multi-column-sort-select',
            'manageLink': '.multi-column-sort-manage a'
        },

        events: {
            'change @ui.switch': 'switchChange',
            'click .multi-column-sort-manage a:not(.disabled)': 'showManageDialog'
        },

        initialize: function() {
            this.label = this.options.label || locale.get('multiSortTitle');
            this.columnCollection = this.options.columnCollection;
            this.multiColumnSort = this.options.multiColumnSort;
            this.multiColumnSortStateColumns = this.options.multiColumnSortState[0] || [];
            this.multiColumnSortStateEnabled = this.options.multiColumnSortState[1] || false;

            this.listenTo(this, 'turnOff', function() {
                this.toggleSwitch(false);
            });
        },

        serializeData: function() {
            return {
                label: this.label,
                gridId: this.options.grid.cid
            };
        },

        onRender: function() {
            this.sortOnLoad();
        },

        sortOnLoad: function() {
            if (!this.multiColumnSortStateEnabled) {
                return;
            }
            this.ui.manageLink.removeClass('disabled');
            this.ui.switch.prop('checked', true);
            this.applyMultiColumnSort(this.getTargetCollection());
        },

        toggleSwitch: function(checked) {
            this.ui.switch.prop('checked', checked).trigger('change');
        },

        switchChange: function() {
            if (this.ui.switch.is(':checked')) {
                this.sortOn();
            } else {
                this.sortOff();
            }
        },

        sortOn: function() {
            this.ui.manageLink.removeClass('disabled');
            this.showManageDialog();
        },

        sortOff: function() {
            if (!this.ui.manageLink.hasClass('disabled')) {
                this.ui.manageLink.addClass('disabled');
                this.unApplyMultiColumnSort();
            }

            if (!util.isNullOrUndefined(this.manageDialogLayout)) {
                this.manageDialogLayout.close();
            }
        },

        getSortedColumnsCollection: function() {
            var columnCollectionJSON = this.columnCollection.toJSON();

            columnCollectionJSON = util.reduce(columnCollectionJSON, function(result, column, i) {
                if (!column.disableMultiSort && column.condition !== false && this.multiColumnSortStateColumns.indexOf(column.field) === -1) {
                    column.id = column.id || i;
                    result.push(column);
                }
                return result;
            }, [], this);

            return new Collection(columnCollectionJSON);
        },
        getTargetCollection: function() {
            var columnCollectionJSON = this.columnCollection.toJSON(),
                targetCollectionJSON = [];

            if (!this.multiColumnSortStateColumns) {
                return new Collection();
            }

            util.each(this.multiColumnSortStateColumns, function(stateColumn) {
                util.each(columnCollectionJSON, function(column, i) {
                    if (stateColumn === column.field && !column.disableMultiSort && column.condition !== false) {
                        column.id = column.id || i;
                        targetCollectionJSON.push(column);
                    }
                });
            });

            return new Collection(targetCollectionJSON);
        },
        showManageDialog: function(e) {
            var dialogTitle = locale.get('configure') + ' ' + this.label,
                manage = e ? this.$(e.currentTarget).parent().hasClass('multi-column-sort-manage') : false;

            this.manageDialogLayout = this.manageDialogLayout || new ManageDialogLayout({
                sortedColumnsCollection: this.getSortedColumnsCollection(),
                targetCollection: this.getTargetCollection(),
                listBuilderOptions: this.options.listBuilderOptions || {},
                dialogTitle: dialogTitle,
                view: this
            });

            if (manage) {
                this.manageDialogLayout.setManage(manage);
            }

            dialog.open(this.manageDialogLayout);
        },

        applyMultiColumnSort: function(sortingCollection) {
            var tieBreakerModel,
                applyMultiColumnSortCollection = sortingCollection.clone();

            if (this.options.listBuilderOptions && this.options.listBuilderOptions.tieBreaker) {
                var tieBreakerColumn = this.options.listBuilderOptions.tieBreaker;

                tieBreakerModel = this.columnCollection.where({
                    field: tieBreakerColumn
                });

                var noTieBreaker = !applyMultiColumnSortCollection.where({
                    field: tieBreakerColumn
                }).length;

                if (noTieBreaker) {
                    applyMultiColumnSortCollection.add(tieBreakerModel);
                }
            }

            this.options.grid.applyMultiColumnSort(applyMultiColumnSortCollection);
            this.options.grid.changeCurrentPage(1);
        },

        unApplyMultiColumnSort: function() {
            this.options.grid.unApplyMultiColumnSort();
        }
    });
});

